import { createClient } from "@sanity/client";

export const clientCMS = createClient({
  projectId: "aqjdfjr3",
  dataset: process.env.REACT_APP_SANITY_DATASET,
  apiVersion: "2024-01-01",
  useCdn: false,
});
